<article class="dialog">
  <div class="dialog__header">
    <span>Attribute search</span>
    <mds-icon
      (click)="closeModal()"
      [key]="icon.CLOSE"
      [pathColors]="['#547080']"
      class="pointer"
      [width]="24"
      [height]="24"
    ></mds-icon>
  </div>

  <mat-dialog-content class="dialog__content">
    <mds-search-bar
      [placeholder]="placeholder"
      [hideEnterButton]="true"
      [theme]="'light'"
      (textChange)="fetchData($event)"
    ></mds-search-bar>

    @if (attributeList.length) {
      @if (isLoading) {
        <mds-loader class="overlay-loader"></mds-loader>
      }
      <div class="attribute-list">
        @for (data of attributeList; track data) {
          <button (click)="getAttributeData(data)">
            <mds-template-card
              [title]="data.title"
              [description]="data.description"
              [icon]="'filter'"
            ></mds-template-card>
          </button>
        }
      </div>
    }

    @if (!attributeList.length) {
      <div class="no-content">
        <span>Found nothing</span>
      </div>
    }
  </mat-dialog-content>
</article>
